import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { GradeLevelUpdateRequest } from "./GradeLevelUpdateRequest";

@Injectable()
export class DataService_GradeLevelSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadGradeLevel() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadGradeLevel?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GradeLevelUpdateInfo(parms: GradeLevelUpdateRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GradeLevelUpdateInfo";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictGradeLevelMoveUp(CurrentGradeLevelID, PreviousGradeLevelID) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/DistrictGradeLevelMoveUp?CurrentGradeLevelID=" + CurrentGradeLevelID + "&PreviousGradeLevelID=" + PreviousGradeLevelID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DistrictGradeLevelMoveDown(CurrentGradeLevelID, PreviousGradeLevelID) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/DistrictGradeLevelMoveDown?CurrentGradeLevelID=" + CurrentGradeLevelID + "&PreviousGradeLevelID=" + PreviousGradeLevelID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
